import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Hittat bostad?", -1)
const _hoisted_3 = { class: "content-section" }
const _hoisted_4 = { class: "card card-feat" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "my-3 row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-danger" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Du är varmt välkommen att skicka in ett objekt när du har gått in i budgivning.")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "question" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "question" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-danger" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Vänligen kontrollera så alla fält ovan är ifyllda.")
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  type: "submit",
  class: "mt-3"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 alert mt-1 alert-secondary" }, [
      /*#__PURE__*/_createElementVNode("small", null, " Lånelöftet du har fått genom oss måste anpassas till den lägenhet eller det hus som du vill köpa - precis som hos alla andra banker. För att undvika negativa överraskningar rekommenderar vi därför att du tar kontakt med oss genom formuläret nedan så snart du börjar närma dig att köpa en viss bostad. Innan du skriver kontrakt. Vi har bevakning på dessa ärenden och prioriterar dem, men du kan självklart också ringa oss (020252626) om det är brådskande - t.ex. om du vet att du kommer vinna budgivningen. ")
    ])
  ])
], -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Tack! Vi har mottagit ditt meddelande.", -1)
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortgageTopMenu = _resolveComponent("MortgageTopMenu")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_Number = _resolveComponent("Number")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MortgageTopMenu, {
        showFoundProperty: true,
        active: "Hittat bostad?",
        showMortgageCalculator: _ctx.app.showMortgageCalculationForActiveApp
      }, null, 8, ["showMortgageCalculator"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.submitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("form", {
                      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_TextField, {
                          label: "Länk till bostad (från t.e.x Hemnet)",
                          modelValue: _ctx.property.url,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.property.url) = $event)),
                          placeholder: "www.exempel.se/bostad123"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_SelectInput, {
                          modelValue: _ctx.status,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status) = $event)),
                          label: "Hur långt har du kommit i köpet?",
                          options: _ctx.options,
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkStatus()))
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      (_ctx.statusText == 'Jag ska på visning')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_Number, {
                            modelValue: _ctx.property.loanAmount,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.property.loanAmount) = $event)),
                            ref: "existingLoanAmount",
                            required: true,
                            label: "Bostadspris",
                            money: true
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_Number, {
                            modelValue: _ctx.property.downPayment,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.property.downPayment) = $event)),
                            ref: "existingLoanAmount",
                            required: true,
                            label: "Hur mycket ska du lägga i kontantinsats?",
                            money: true
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      (_ctx.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                            disabled: 
                          _ctx.statusText == 'Jag ska på visning' ||
                          _ctx.property.loanAmount == null ||
                          _ctx.property.downPayment == null ||
                          _ctx.property.url == null ||
                          _ctx.property.url == ''
                        
                          }, " Skicka ", 8, _hoisted_22)
                        ])
                      ])
                    ], 32)
                  ]),
                  _hoisted_23
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
                  class: "btn btn-primary ms-2"
                }, " Mina sidor ")
              ])),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.errorMessage), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}